export enum FieldSettingEditType {
    Text,
    Number,
    Checkbox,
    Dropdown,
    RadioButtons,
    RecordSelect,
    ModelSelect,
    DisplayFields,
    FieldMapping
}